<template> 
	<div id="kontakt" class='page'>
		<div class="contact-col">
			<h1>
				 {{p.headline}}
			</h1>
			<p v-if='!send' class='subline'>
				 {{p.subline}}
			</p>
		</div>
		<div class="contact-col"> 
			<div id="input-set" class='page-content'
			data-aos="fade-in"
			:data-aos-duration=1000
			>

			<div v-if='send' class='thanks'>
				<h2> 
					{{p.dankenachricht}}
				</h2> 
			</div>				
			<div v-if='!send' class="inputs">
				<input  id='name' :placeholder='p.name' type="text" name="name" v-model='name'>
				<input  id='phone' :placeholder='p.phone' type="tel" name="phone" v-model='phone' >
				<input id='email' :placeholder='p.email' type="email" name="email" v-model='email' v-bind:class="{ required: isEmail() }">

				<textarea  id='nachricht' :placeholder='p.nachricht' name="nachricht" v-model='text' v-bind:class="{ required: isText() }"></textarea>
				<label for="privacy"  style="word-wrap:break-word" v-bind:class="{ required: isChecked()}">
					<input id="privacy"  type="checkbox" v-model='privacy' v-bind:class="{ required: isChecked()}" />Bitte lesen Sie unsere <a href='/datenschutz'>Datenschutzbestimmungen</a>
				</label>			
				<div v-on:click='submit' id="add-button">{{p.absenden}}</div>

			</div>

			<!-- <div v-if='!send' class="forgot require">{{p.pflichtfelder}}</div> -->

		</div>

	</div>
</div>
</template>

<script>
	// import Client from '@/components/Client.vue'
	// import db from '@/components/firebaseinit'
	// import firebase from 'firebase'
	// const users = db.collection('users')

	export default {
		name: 'kontakt',
		components: {
			
		},
		props: {
		    langsufix: String,
		    sidenav: Array,
		    isAdmin: Boolean,
		},  
		data () {
			return {
				vorname: '',
				name: '',
				text: '',
				email: '',
				phone: '',
				privacy: false,
				required: false,
				send: false,
				p: {} 

			}
		},
		// firestore: { 
		// 	users: db.collection('clients').orderBy('createAt','desc') 
		// },
		created () {
			this.getContent();
			this.send = false; 
		},
		methods: { 
			submit() {
				console.log('submit'); 
				if(this.text && this.validEmail(this.email)) { 
					this.$http.post('https://us-central1-sfsweb.cloudfunctions.net/api/submit', {
						name: this.name,
						phone: this.phone,
						email: this.email,
						text: this.text,
					}).then((response) => {
						console.log(response); 
						this.send = true; 
					});
				} else {
					this.required = true; 
					console.log('reuqired!!');
				}

			},
			isText() {
				if(this.required) {
					if(!this.text) {
						return true
					} else {
						return false
					}
				}
			},
			isEmail() {
				var isRealMail = this.validEmail(this.email)
				if(this.required) {

					if(!this.email || !isRealMail ) {
						return true
					} else {
						return false
					}
				}
			},
			isChecked() {
				// var isChecked = true
				if(this.required) {

					if(!this.privacy ) {
						return true
					} else {
						return false
					}
				}
			},
			validEmail(email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    			return re.test(String(email).toLowerCase());	
			},			
			getContent () {
			  this.$prismic.client.getByUID('contact','contact-'+this.langsufix)
			    .then((document) => {
			      console.log(document);
			      this.p = document.data;
			    })
			},   

		}
	}
</script>

<style lang="less" scoped>
@import '../less/variables.less';

#kontakt {
	background-color: #FBFBFB;
	padding-top: 40px;
	padding-bottom: 70px;
}

.contact-col {
	display: inline-block;
	vertical-align: top;
	text-align: left;
	width: 45%;


	&.right { 
		margin-left: 40px;
	}

	h1 {
		.fmb(40px);
		color: @g1;
		text-transform: uppercase;


	}

	p {
		.fm(12px);
		color: rgba(0,0,0,0.6);
		width: 50%;
		min-width: 250px;
	}
		@media (max-width: @mobile_width) { 
	        .fmb(46px);
	        line-height: 46px;
	        display: inherit;
	        width: 100%;
	        // padding-bottom: 100px;

	        p {
	        	width: 100%;	
	        }
	    }   	
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.page-content {
	// top: -100px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

#login {
	// margin-top: 300px;
}
#input-set { 

	.inputs {
		position: relative;
		margin-top: 30px;
	}
	.thanks {
		h2 {
			.fmb(20px); 
		}

	}
	#checkboxs {
		display: inline-block;
		width: 100px;
		background-color: red;
	}
	a {
		color: @g1;
	}
	label {
		vertical-align: top;
		// background-color: green;
		height: 150px;
		color: @g1;
		clear: both;
		.fm(14px);
		margin-left: 5px;
		&.required {
			color: red;
		}
	
	}
	input[type="checkbox"]
	{
	    vertical-align:middle;
	    float: left;
	    .fm(14px);

	    border-color: red;
	    border: solid;
	    background-color: red;
	}


	input[type="text"], input[type="tel"], input[type="email"] {
		border: none;
		outline: none;
		text-align: left;
		border-bottom: solid; 
		border-color: @c2;
		border-width: 1px;
		padding: 0px 0px;

		height: 50px;
		width: 100%;
		position: relative;
		.fm(14px);
		margin-bottom: 15px;
		color: @c2; 
		background-color: transparent;

		&.required {
			border-color: red;
		}		
	}
	textarea {
		border: none;
		outline: none;
		text-align: left;
		border: solid; 
		border-color: @c2;
		border-width: 1px;
		padding: 10px 10px;
		height: 100px;
		width: 95%;
		position: relative;
		.fm(14px);
		margin-bottom: 15px;
		color: @c2; 
		background-color: transparent;
		&.required {
			border-color: red;
		}
	}
	::placeholder { 
		color: @c2;
		.fm(14px);
		text-transform: uppercase;
	} 
	#add-button {
		// .br(2px);
		.fmb(12px);
		line-height: 40px;
		color: @c2;
		height: 40px;
		position: relative;
		text-align: left;
		left: 0px;
		// float: left;
		cursor: pointer;
		margin-top: 10px;
		background-color: @c3;
		display: table;
		text-transform: uppercase;
		padding-left: 20px;
		padding-right: 20px;
		border: solid;
		margin-top: 20px;
		// .login-icon {
		// 	position: absolute;
		// 	width: 50px;
		// 	height: 50px;
		// 	margin-left: 20px;
		// 	display: inline-block;
		// 	// background-image: url('/images/arrow-right.svg');
		// 	background-position: center center;
		// 	background-size: 60% auto;
		// 	background-repeat: no-repeat; 
		// } 
		&:hover {
			background-color: rgba(0,0,0,0.1); 
		}
	}
} 
</style>
